// extracted by mini-css-extract-plugin
module.exports = {"size":"VideoPlayer_size__3Bqw3"};